import { InputLabel } from '@mui/material';
import { disabledTextAreaInputStyles } from '@Components/Form/styles';
import FormTextAreaAutoSize from '@Components/Form/FormTextAreaAutosize';

type GoalNameFormFieldsProps = {
  planIndex: number;
  riskIndex: number;
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const GoalNameFormFields = ({
  riskIndex,
  planIndex,
  isCompletedTh = false,
  isCompletedEn = false,
}: GoalNameFormFieldsProps) => {
  return (
    <>
      <InputLabel required>ชื่อความเสี่ยง</InputLabel>
      <FormTextAreaAutoSize
        name={`companyValueIncreasePlans.valueUpPlans.${planIndex}.riskManagement.risks.${riskIndex}.nameTh`}
        inputProps={{
          minRows: 3,
          placeholder: 'กรุณาระบุชื่อความเสี่ยง (ไทย)',
        }}
        label={'ภาษาไทย'}
        sx={
          isCompletedTh ? { ...disabledTextAreaInputStyles, mt: 2 } : { mt: 2 }
        }
      />
      <FormTextAreaAutoSize
        name={`companyValueIncreasePlans.valueUpPlans.${planIndex}.riskManagement.risks.${riskIndex}.nameEn`}
        inputProps={{
          minRows: 3,
          placeholder: 'กรุณาระบุชื่อความเสี่ยง (อังกฤษ)',
        }}
        label={'ภาษาอังกฤษ'}
        sx={
          isCompletedEn ? { ...disabledTextAreaInputStyles, mt: 2 } : { mt: 2 }
        }
      />
    </>
  );
};

export default GoalNameFormFields;
